/**
 * Product Reviews JavaScript
 * Asymmetric slider with center focus
 * Performance Optimized
 */

(function() {
  'use strict';

  class ProductReviews {
    constructor() {
      this.section = document.querySelector('[data-product-reviews]');
      if (!this.section) return;

      this.track = this.section.querySelector('[data-reviews-track]');
      this.slides = this.section.querySelectorAll('.product-reviews__slide');
      this.prevButton = this.section.querySelector('[data-reviews-prev]');
      this.nextButton = this.section.querySelector('[data-reviews-next]');
      
      if (!this.track || this.slides.length === 0) return;

      this.currentIndex = 2; // Start from center (3rd slide, index 2)
      this.isMobile = window.innerWidth <= 749;
      this.isInitialLoad = true; // Flag to prevent scroll on initial load
      
      this.init();
    }

    init() {
      if (this.isMobile) {
        // Mobilde JS slider'ı devre dışı bırak, native scroll kullan
        this.track.style.transform = 'none';
        return;
      }
      
      this.setupSlides();
      this.setupNavigation();
      this.setupResize();
      this.updateSlider(false); // Don't scroll on initial load
      // Reset flag after initial setup
      setTimeout(() => {
        this.isInitialLoad = false;
      }, 100);
    }

    setupSlides() {
      // Set initial center slide
      if (this.slides.length > 2) {
        this.setCenterSlide(2);
      }
    }

    setupNavigation() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => {
          this.prevSlide();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.nextSlide();
        });
      }

      // Keyboard navigation
      this.section.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prevSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });
    }

    setupResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const wasMobile = this.isMobile;
          this.isMobile = window.innerWidth <= 749;
          
          if (wasMobile !== this.isMobile) {
            // Mod değişikliğinde JS'i resetle
            if (this.isMobile) {
              this.track.style.transform = 'none';
            } else {
              this.updateSlider(false);
            }
          } else if (!this.isMobile) {
            this.updateSlider(false);
          }
        }, 250);
      });
    }

    prevSlide() {
      if (this.isMobile) {
        this.currentIndex = Math.max(0, this.currentIndex - 1);
      } else {
        this.currentIndex = Math.max(2, this.currentIndex - 1);
      }
      this.updateSlider(true);
    }

    nextSlide() {
      if (this.isMobile) {
        this.currentIndex = Math.min(this.slides.length - 1, this.currentIndex + 1);
      } else {
        this.currentIndex = Math.min(this.slides.length - 3, this.currentIndex + 1);
      }
      this.updateSlider(true);
    }

    updateSlider(shouldScroll = false) {
      if (this.isMobile) {
        this.updateMobileSlider(shouldScroll);
      } else {
        this.updateDesktopSlider();
      }
    }

    updateMobileSlider(shouldScroll = false) {
      // Mobile: use transform instead of scrollIntoView to prevent page scroll
      const slide = this.slides[this.currentIndex];
      if (!slide) return;
      
      // Calculate position to center the current slide
      const slideWidth = slide.offsetWidth;
      const gap = parseInt(window.getComputedStyle(this.track).gap) || 20;
      const containerWidth = this.track.parentElement.offsetWidth;
      
      // Calculate position to center the current slide
      const totalSlideWidth = slideWidth + gap;
      const slidePosition = this.currentIndex * totalSlideWidth;
      const centerOffset = (containerWidth - slideWidth) / 2;
      
      const offset = centerOffset - slidePosition;
      
      // Apply smooth transition only on user interaction
      if (shouldScroll && !this.isInitialLoad) {
        this.track.style.transition = 'transform 0.3s ease';
      } else {
        this.track.style.transition = 'none';
      }
      
      this.track.style.transform = `translateX(${offset}px)`;
    }

    updateDesktopSlider() {
      // Desktop: center the selected slide
      this.setCenterSlide(this.currentIndex);
      
      // Update all slide sizes and opacity based on position
      this.slides.forEach((slide, i) => {
        const distance = Math.abs(i - this.currentIndex);
        
        if (distance === 0) {
          // Center slide
          slide.style.width = '320px';
          slide.style.opacity = '1';
          slide.style.transform = 'scale(1)';
        } else if (distance === 1) {
          // Adjacent slides
          slide.style.width = '240px';
          slide.style.opacity = '0.8';
          slide.style.transform = 'scale(0.95)';
        } else if (distance === 2) {
          // Edge slides
          slide.style.width = '180px';
          slide.style.opacity = '0.6';
          slide.style.transform = 'scale(0.9)';
        } else {
          // Hidden slides
          slide.style.opacity = '0.3';
          slide.style.transform = 'scale(0.85)';
        }
      });
      
      // Calculate transform to center the selected slide
      requestAnimationFrame(() => {
        const centerSlide = this.slides[this.currentIndex];
        if (!centerSlide) return;

        const trackRect = this.track.getBoundingClientRect();
        const slideRect = centerSlide.getBoundingClientRect();
        const slideLeft = slideRect.left - trackRect.left;
        const trackCenter = trackRect.width / 2;
        const slideCenter = slideRect.width / 2;
        const offset = trackCenter - slideLeft - slideCenter;

        this.track.style.transform = `translateX(${offset}px)`;
      });
    }

    setCenterSlide(index) {
      // Remove center attribute from all slides
      this.slides.forEach((slide, i) => {
        if (i === index) {
          slide.setAttribute('data-center', 'true');
        } else {
          slide.removeAttribute('data-center');
        }
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductReviews();
    });
  } else {
    new ProductReviews();
  }

  // Re-initialize on section load (for Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section && section.hasAttribute('data-product-reviews')) {
          new ProductReviews();
        }
      }
    });
  }
})();

